const API_CONFIG = {
  tekno: `http://${window.location.hostname}:5555/api`,
  "aws-tekno": "https://accounting.iotech.my.id/api",
  "aws-intercon": "https://accounting-intercon.iotech.my.id/api",
  default: "http://localhost:5555/api", // Fallback
};

module.exports = API_CONFIG;
